(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('platform2-');
        $sessionStorageProvider.setKeyPrefix('platform2-');
    }
})();
